import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import clsx from 'clsx'
import { handlePreviousStep } from '../../pages/CreateRequestStepper.js/components/Repair/utils/updateStepState'

const MainHeading = ({
    title,
    subtitle,
    actions,
    content,
    isBlack = false,
    isTabletViewPort = false,
    hasGoBack = false,
    steps,
    setSteps,
    listOfRequests,
    setSelectedAsset,
}) => {
    const history = useHistory()

    const onGoBack = () => {
        if (steps) {
            const activeStep = steps?.find(step => step.active === true)
            handlePreviousStep({
                steps,
                setSteps,
                currentStepName: activeStep?.name,
                history,
                listOfRequests,
                setSelectedAsset,
            })
        } else {
            history?.goBack()
        }
    }

    return (
        <header
            className={clsx(
                'sticky top-0 px-6 py-4 flex flex-col items-start justify-start w-full border-b border-grayLines z-120 gap-y-4 h-auto',
                isBlack ? 'bg-black60' : 'bg-white',
            )}
        >
            <div
                className={clsx(
                    'w-full h-auto flex md:flex-row flex-col md:items-center items-start justify-between gap-4',
                    isTabletViewPort && 'lg:flex-nowrap flex-wrap',
                )}
            >
                <div className="flex flex-col w-auto  max-w-min items-start justify-start">
                    {hasGoBack && (
                        <p
                            role="button"
                            onClick={onGoBack}
                            className="text-textDarkGray text-sm font-medium"
                        >
                            {'< Go Back'}
                        </p>
                    )}
                    <div
                        className={clsx(
                            'font-medium text-xl w-max truncate',
                            isBlack ? 'text-white' : 'text-black',
                        )}
                    >
                        {title}
                    </div>
                    {subtitle && (
                        <p
                            className={clsx(
                                'font-medium text-sm w-max truncate',
                                isBlack
                                    ? 'text-textDarkGray'
                                    : 'text-textDarkGray',
                            )}
                        >
                            {subtitle}
                        </p>
                    )}
                </div>
                {actions && (
                    <div className="flex flex-grow w-full h-full md:justify-end justify-start gap-x-2">
                        {actions &&
                            actions?.map((action, index) => (
                                <div
                                    key={`action-${index}`}
                                    className={clsx(
                                        isTabletViewPort
                                            ? 'lg:w-auto w-full'
                                            : 'md:w-auto w-full',
                                    )}
                                >
                                    {action}
                                </div>
                            ))}
                    </div>
                )}
            </div>
            {content && (
                <div className="w-full h-auto flex-grow">{content}</div>
            )}
        </header>
    )
}

MainHeading.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    subtitle: PropTypes.string,
    actions: PropTypes.arrayOf(PropTypes.node),
    content: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.node,
        PropTypes.any,
    ]),
    isBlack: PropTypes.bool,
    isTabletViewPort: PropTypes.bool,
    hasGoBack: PropTypes.bool,
    hasToCancel: PropTypes.bool,
    steps: PropTypes.array,
    setSteps: PropTypes.func,
    listOfRequests: PropTypes.array,
    setSelectedAsset: PropTypes.func,
}

export default MainHeading
